import { Component, input, Input } from '@angular/core'
import { AbstractControl, FormControl } from '@angular/forms'

@Component({
  selector: 'app-error-message',
  imports: [],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.scss'
})
export class ErrorMessageComponent {
  @Input() control!: FormControl | AbstractControl
  errorMessage = input<string>('')
  name = input<string>('')
  errorCode = input<string>('required')

  get shouldShowError(): boolean {
    return (
      this.control.invalid &&
      (this.control.dirty || this.control.touched) &&
      this.control.hasError(this.errorCode())
    )
  }

  get displayMessage(): string {
    return this.name()
      ? `${this.name()} ${this.errorMessage()}`
      : `This field ${this.errorMessage()}`
  }
}
